import { categoryNames, frequencies, normalizeCategory, priorities } from "../constants";
import { createId } from "./formatters";

const splitCsvLine = (line) => {
  const values = [];
  let current = "";
  let inQuotes = false;

  for (let index = 0; index < line.length; index += 1) {
    const char = line[index];
    const next = line[index + 1];

    if (char === '"' && next === '"') {
      current += '"';
      index += 1;
    } else if (char === '"') {
      inQuotes = !inQuotes;
    } else if (char === "," && !inQuotes) {
      values.push(current.trim());
      current = "";
    } else {
      current += char;
    }
  }

  values.push(current.trim());
  return values;
};

export const parseCsvExpenses = (text, userId, fallbackCurrency) => {
  const lines = text
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  if (lines.length < 2) {
    return [];
  }

  const headers = splitCsvLine(lines[0]).map((header) => header.toLowerCase());

  return lines
    .slice(1)
    .map((line) => {
      const values = splitCsvLine(line);
      const row = headers.reduce((record, header, index) => {
        record[header] = values[index] || "";
        return record;
      }, {});

      const amount = Number(row.amount || row.value || 0);
      const date = row.date ? new Date(row.date) : new Date();
      const category = categoryNames.includes(row.category) ? row.category : normalizeCategory(row.category);
      const frequency = frequencies.includes(row.frequency) ? row.frequency : "One-time";
      const priority = priorities.includes(row.priority) ? row.priority : "Medium";

      if (!row.title || !amount || Number.isNaN(date.getTime())) {
        return null;
      }

      return {
        id: createId(),
        title: row.title,
        amount,
        date: date.toISOString(),
        category,
        description: row.description || "",
        tags: row.tags ? row.tags.split("|").map((tag) => tag.trim()).filter(Boolean) : [],
        frequency,
        priority,
        currency: row.currency || fallbackCurrency,
        userId,
        receiptName: "",
        receiptDataUrl: "",
        receiptType: "",
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      };
    })
    .filter(Boolean);
};
